module.exports = __webpack_public_path__ + "img/list.1da79790.svg";